<template>
  <div class="page">

    <div v-if="model != null">
      <van-panel class="panel-info">
        <van-cell slot="header" icon="orders-o" title="分销入驻订单">
          <van-tag v-if="model.status == 0" type="primary">待付款</van-tag>
          <van-tag v-else-if="model.status == 1" type="success">已付款</van-tag>
        </van-cell>
        <!--    用户信息      -->
        <van-cell class="cell-padding" size="large" center
                  :clickable="isAuthority()"
                  :is-link="isAuthority()"
                  :to="isAuthority() ? '/admin/user/detail/'+ model.userId:null">
          <div class="user-item">
            <div class="left align-center">
              <div class="user_head">
                <van-image
                    round
                    width="60px"
                    height="60px"
                    :src="model.headImgUrl">
                </van-image>
                <div class="avatarFrame" v-if="model.levelFrameUrl">
                  <img width="80px" height="80px" :src="model.levelFrameUrl"/>
                </div>
                <van-tag v-if="model.levelName" class="level" type="primary" round size="medium">{{ model.levelName }}</van-tag>
              </div>
              <div class="padding-left-sm">
                <!-- id 已关注 黑名单 -->
                <div class="left-sm-tag">
                  <van-tag plain type="primary">ID：{{ model.userId }}</van-tag>
                </div>
                <!-- 用户昵称 1条违规 -->
                <div>
                  <span>{{ model.nickname }}</span>
                </div>
              </div>
            </div>
            <div class="right">
            </div>
          </div>
        </van-cell>
        <div class="content">
          <div class="row">
            <span class="label">分销等级</span>
            <span class="value">{{model.name}}</span>
          </div>
          <div class="row">
            <span class="label">订单号</span>
            <span class="value">{{model.no}}</span>
          </div>
          <div class="row">
            <span class="label">下单时间</span>
            <span class="value">{{formatDate(model.createTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
          <div class="row">
            <span class="label">订单金额</span><span class="value">￥{{formatPrice(model.payAmount)}}</span>
          </div>
        </div>
      </van-panel>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Panel, Cell, CellGroup, Button, Tag, Icon, Toast, Dialog, Field, Image} from 'vant';
  import Decimal from 'decimal.js';
  import moment from 'moment';
  import { getOrder} from '@/api/admin/distributor-pay-order'

  Vue.use(Panel)
      .use(Cell)
      .use(CellGroup)
      .use(Button)
      .use(Tag)
      .use(Icon)
      .use(Toast)
      .use(Dialog)
      .use(Field)
      .use(Image)

  export default {
    name: 'distributor-pay-order-detail',
    components:{
    },
    data () {
      return {
        model: null,
        refundFee: null,
        refundReason: null,
        refundShow: false,
        payAmount: null,
        sumRefundFee: null,
        canRefundFee: null,
        msg: null,
      }
    },
    methods: {
      //判断权限
      isAuthority(){
        return this.$hasRole('super_admin') || this.$AdminAccess.includes('user-manage')
      },
      formatDate(date, format) {
        if (!date) {
          return '';
        }
        if (!format) {
          format = 'YYYY-MM-DD'
        }
        return moment(date).format(format);
      },
      formatPrice(price) {
        if (price != null) {
          return Decimal.div(price, 100).toString()
        }
        return ''
      },
      loadData() {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getOrder(this.$route.params.id).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.model = data.order;
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      },
    },
    mounted() {
      this.loadData()
    },
    updated() {
      // 统一替换标签
      this.$replaceLabel(document.body, this.$store.state.label, true)
    }
  }
</script>

<style lang="less" scoped>

  .page {
    padding-bottom: 100px;

    .panel-info {
      margin-top: 10px;
      .cell-padding{
        padding: 5px 15px 10px;

        .user-item {
          display: flex;
          align-items: center;
          .userMemo {
            color: #999;
          }
          .left {
            flex: 1;
            display: flex;
            .service-info {
              color: #333;
            }
            .created {
              color: #555;
              margin-bottom: 5px;
            }
            .user_head {
              position: relative;
              padding: 10px;
              .avatarFrame {
                position: absolute;
                top: 0;
                left: 0;
              }
              .level {
                position: absolute;
                left: 50%;
                height: 10px;
                font-size: 10px;
                white-space: nowrap;
                bottom: 0px;
                transform: translateX(-50%);
              }
            }
            .padding-left-sm div span{
              margin-right: 4px;
            }
            .recommend{
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              color: #999999;
            }
          }
          .right {
            text-align: right;
            min-width: 30px;
            .total-amount {
              color: #333;
            }
          }
        }
      }
      .content {
        font-size: 14px;
        padding: 0 15px 10px;
      }
    }
    .row {
      display: flex;
      color: #333;
      margin: 10px 0;
      align-items: center;
    }
      .label {
        width: 80px;
        color: #888;
      }

      .value {
        flex: 1;
      }
    .commentBox{
      width: 100%;
      background: #fff;
      padding: 15px;
      margin-top: 20px;
      box-sizing: border-box;
    }
    .imgStyle{
      margin-left: 10px;
      flex: 0 0 15%;
      height: 0;
      padding-bottom: 15%;
      overflow: hidden;
      position: relative;
    }
    .screenshot{
      width: 100%;
      display: flex;
      align-content: flex-start;
      flex-flow: row wrap;
    }
    .screenshotImg{
      width: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }


</style>
